import React, {useState, useEffect} from 'react';
import loadable from '@loadable/component'

const SearchPage = loadable(() => import('./components/search-page'));

const SearchPageContainer = props => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if(!mounted) setMounted(true);
  }, []);

  return (
    <div classMame='search-page-container'>
      { mounted && <SearchPage /> }
    </div>
  );
}

export default {
  component: SearchPageContainer
};
